import {
  getAuthHeaders,
  removeAuthHeaders,
  setAuthHeaders,
} from './session.js';

let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (callback) => {
  refreshSubscribers.push(callback);
};

const onRefreshed = (newAuthToken) => {
  refreshSubscribers.forEach((callback) => callback(newAuthToken));
  refreshSubscribers = [];
};

const onRefreshFailed = () => {
  refreshSubscribers.forEach((callback) => callback(null));
  refreshSubscribers = [];
};

export const refreshAccessToken = async (apiUrl) => {
  if (isRefreshing) {
    return new Promise((resolve) => {
      subscribeTokenRefresh((newAuthToken) => {
        resolve(newAuthToken);
      });
    });
  }

  isRefreshing = true;

  try {
    const response = await fetch(`${apiUrl}/api/v1/sessions/refresh`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
    });

    if (!response.ok) {
      throw new Error('Refresh failed');
    }

    const data = await response.json();
    const { user, auth_token } = data;

    if (!user || !auth_token) {
      throw new Error('Invalid refresh response');
    }

    setAuthHeaders(auth_token);

    isRefreshing = false;
    onRefreshed(auth_token);

    return auth_token;
  } catch (error) {
    isRefreshing = false;
    onRefreshFailed();
    removeAuthHeaders();
    return null;
  }
};

export const isRefreshingToken = () => isRefreshing;
